export default __webpack_public_path__ + "static/media/foto3.8cc9efb3.jpg";